import React from 'react';
import {Box, Input as NativeInput, FormControl} from 'native-base';
import {FieldError, UseControllerProps, useController} from 'react-hook-form';
import {message} from './../../../utils/messages';
import {EyeOffIcon, EyeOnIcon} from './../../icons';
import {defaultProps} from './../constants';

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
  disabled?: boolean;
}
const PasswordInput = (props: Props) => {
  const {label, error, control, name, rules, defaultValue, disabled} = props;
  const {field} = useController({control, defaultValue: '', name, rules});
  const [show, setShow] = React.useState(false);
  const [textValue, setTextValue] = React.useState('');

  React.useEffect(() => {
    if (defaultValue !== null) {
      setTextValue(defaultValue);
      field.onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const handleChangeText = (value: string) => {
    setTextValue(value);
    field.onChange(value);
  };

  const getIconColor = () => {
    if (error) {
      return 'red.500';
    }
    return '#0088FF';
  };

  const onPressIcon = () => {
    if (disabled) {
      return;
    }
    setShow(!show);
  };

  return (
    <Box width="100%">
      <FormControl isRequired isInvalid={error !== undefined}>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <NativeInput
          type={show ? 'text' : 'password'}
          InputRightElement={
            show ? (
              <EyeOffIcon
                width="32"
                height="32"
                color={getIconColor()}
                mr="5"
                onPress={onPressIcon}
              />
            ) : (
              <EyeOnIcon
                width="32"
                height="32"
                color={getIconColor()}
                mr="5"
                onPress={onPressIcon}
              />
            )
          }
          {...defaultProps}
          _focus={{
            borderColor: 'blue.400',
          }}
          value={textValue}
          onChangeText={handleChangeText}
          isDisabled={disabled}
        />

        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default PasswordInput;
